(function () {
  function formatRupees(number) {
    return "₹" + Math.round(number).toLocaleString("en-IN");
  }

  function showToast(page, message) {
    var toast = page.querySelector("[data-hitea-toast-box]");
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add("show");

    window.setTimeout(function () {
      toast.classList.remove("show");
    }, 2200);
  }

  function setProgress(page, percent) {
    var safePercent = Math.min(100, Math.max(0, percent));

    var pct = page.querySelector("[data-hitea-pct]");
    var rupees = page.querySelector("[data-hitea-rupees]");
    var bar = page.querySelector("[data-hitea-bar]");
    var barWrap = page.querySelector("[data-hitea-bar-wrap]");

    if (pct) pct.textContent = safePercent + "% started";
    if (rupees) rupees.textContent = formatRupees((safePercent / 100) * 300000);
    if (bar) bar.style.width = safePercent + "%";
    if (barWrap) barWrap.style.setProperty("--cup-left", safePercent + "%");
  }

  function initHiTeaDiwaliPage(page) {
    if (!page || page.dataset.hiteaReady === "true") return;

    page.dataset.hiteaReady = "true";

    var cups = 0;
    var progress = 18;

    setProgress(page, progress);

    var cupCountNodes = page.querySelectorAll("[data-hitea-cup-count]");
    var addCupButtons = page.querySelectorAll("[data-hitea-add-cup]");
    var toastButtons = page.querySelectorAll("[data-hitea-toast]");

    addCupButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        cups += 1;
        progress = Math.min(100, progress + 2);

        cupCountNodes.forEach(function (node) {
          node.textContent = cups;
        });

        setProgress(page, progress);
        showToast(page, "Cup added to your habit score");
      });
    });

    toastButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var message = button.getAttribute("data-hitea-toast") || "Done";
        showToast(page, message);
      });
    });
  }

  function initAllHiTeaDiwaliPages() {
    var pages = document.querySelectorAll(".hitea-diwali-page");
    pages.forEach(initHiTeaDiwaliPage);
  }

  document.addEventListener("DOMContentLoaded", initAllHiTeaDiwaliPages);

  document.addEventListener("shopify:section:load", function () {
    initAllHiTeaDiwaliPages();
  });
})();